import { render, staticRenderFns } from "./commands.vue?vue&type=template&id=55b33bd0&scoped=true&"
import script from "./commands.vue?vue&type=script&lang=js&"
export * from "./commands.vue?vue&type=script&lang=js&"
import style0 from "./commands.vue?vue&type=style&index=0&id=55b33bd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b33bd0",
  null
  
)

export default component.exports